<template>
  <div>
    <button
      type="button"
      class="btn btn-dark btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk
    </button>

    <a-modal v-model="visible" title="Bulk Upload Products" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Upload</a-button>
      </template>

      <a-form :form="form">
        <p class="mt-3 mb-0">Download the CSV file format here.
          <a
            href="/resources/csv/neoskool_product_bulk_import.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Download CSV
          </a>
          <span class="font-weight-bold text-warning">Fields marked with * are required!</span>
        </p>
        <div class="row">
          <div class="col-md-4">
            <a-form-item
              label="CSV File"
            >
              <a-upload
                v-decorator="['file', {rules: [{ required: true, message: 'Please select a csv file to upload!' }]}]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
// import { find } from 'lodash'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'BulkUploadProduct',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload (file) {
      const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },

    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to bulk upload products!`,
            onOk: () => {
              let formData = window.jsonToFormData(values, options)

              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/inventory/product/import', formData)
                .then(() => {
                  this.$emit('created')
                  this.$eventBus.$emit('calendarEventUpdated')
                  this.loading = false
                  this.visible = false
                  this.$notification['info']({
                    message: 'Bulk upload started!',
                    description: `Bulk products import has started! You will be notified once it is completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel() {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
